import $ from "jquery";

export const init = () => {
  $(".news-list-view,.news-search-result").each(function (index) {
    let $this = $(this);
    let itemsPerPage = $this
      .attr("data-items-per-page");
    let moreButton = $this.find(".paginate");

    moreButton.on("click", function () {
      let search = ".blog-teaser.d-none:lt(" + itemsPerPage + ")";
      $this.find(search).removeClass("d-none");

      if (!$this.find(".d-none").length > 0) moreButton.hide();
    });

    if (!$this.find(".d-none").length > 0) moreButton.hide();
  });
};
